(function(angular) {
    angular
        .module('repairforms.service.module')
        .service('InputsPrefillerService', InputsPrefillerService);


    function InputsPrefillerService() {
        return {
            appendValueToStringModel : appendValueToStringModel,
            setFieldValueInModel     : setFieldValueInModel
        };

        function appendValueToStringModel($scope, newValueOfFieldInModel, modelInString) {
            if(typeof modelInString === 'undefined') {
                return;
            }

            var model = $scope;
            var modelParts = modelInString.split('.');
            modelParts.forEach(function(elem, index) {
                model = setFieldValueInModel(model, modelParts, elem, index, newValueOfFieldInModel);
            });

        };

        function setFieldValueInModel(model, modelParts, elem, index, newValueOfFieldInModel){
            if(isValueHolder(modelParts, index)) {
                model = setElementsInModel(model, elem);
            } else {
                model = setElementValueInModel(model, elem, newValueOfFieldInModel);
            }

            return model;
        };

        function isValueHolder(modelParts, index) {
            return index+1 < modelParts.length;
        }

        function setElementValueInModel(model, elem, newValueOfFieldInModel){
            if(model[elem]) {
                model[elem] += ' ';
            }
            model[elem] = newValueOfFieldInModel;

            return model;
        };

        function setElementsInModel(model, elem){
            if(model[elem]) {
                model = model[elem];
            } else {
                return;
            }

            return model;
        };


    }

})(angular);